export const XP_PER_LEVEL = 500

export interface XpProgress {
  totalXp: number
  xpInCurrentLevel: number
  percent: number
  computedLevel: number
}

export function getXpProgress(totalXp: number): XpProgress {
  const normalizedXp = Math.max(0, Math.floor(Number(totalXp ?? 0)))
  const xpInCurrentLevel = normalizedXp % XP_PER_LEVEL
  const percent = Math.max(0, Math.min(100, Math.round((xpInCurrentLevel / XP_PER_LEVEL) * 100)))
  const computedLevel = Math.floor(normalizedXp / XP_PER_LEVEL) + 1

  return {
    totalXp: normalizedXp,
    xpInCurrentLevel,
    percent,
    computedLevel,
  }
}
